/*******************************************************************************************************************
 * File: /assets/js/videoimport.js
 * Imports videojs and prepares the player for use.
 * 
 * Vid player code and various disclaimer work - ABLE DEV
 * 
 * Author: Matt Hawk
 *
 *******************************************************************************************************************/
 import videojs from 'video.js';

export function globalSuccessPlayer () {videojs('vid-global-success');}

export function heroVidPlayer () {
  let vidHeader = videojs('hero-vid-header');

  // Disclaimer pop-up padding
  if (document.body.classList.contains("testimonials")) {
    vidHeader.on("play", () => {
      disclaimerPadding();
    }
    );
  }
}

export function vidSuccessPlayer () {videojs('vid-success');} 

export function lightBoxVidPlayer(dataSrc, dataPoster) {
    let lightBoxVidPlayer = videojs('vid-success');
    lightBoxVidPlayer.src([ 
      { src: dataSrc }
        ]);
    lightBoxVidPlayer.poster(dataPoster);
}

export function lightBoxVidPause() {
  let lightBoxVidPlayer = videojs('vid-success');
  lightBoxVidPlayer.pause();
}

function disclaimerPadding() {
  document.getElementById('mobile-hero-nav-wrapper').classList.add('disclaimer-on');
  document.getElementById('desktop-hero-nav-wrapper').classList.add('disclaimer-on');
}



